import config from 'config';

import Fetch from 'tools/Fetch';

import {
    ENTITY_PATH,
} from '../constants';
import {
    ICancelAccountStatisticResponse,
} from '../responses/cancel-account-statistic.response';

export async function cancelAccountStatisticFetch(encodedId: string): Promise<ICancelAccountStatisticResponse> {
    return new Fetch<ICancelAccountStatisticResponse>({
        url: `${config.CRM_BACKEND_URL}/${ENTITY_PATH}/${encodedId}/cancel`,
        method: 'POST',
    })
        .onEmptyBody([204])
        .on([400, 401, 404, 500], (body) => {
            return body;
        })
        .exec();
}
